module.exports = __webpack_public_path__ + "img/Questionnaire@2x_PT.553791ca.png";